import Moment from 'moment';
import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/deadline-list';
import AggregateMoment from "../../aggregate/aggregate-moment";
import AggregateMomentComponent from "../components/aggregate-moment";
import normalizeDate from "../../import/normalize/normalize-date";
import FieldDateViewInImport from "../../import/view-in-preview/date-view-in-import";

export default class DeadlineField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.DEADLINE;
    }

    get sortHintMessage() {
        return 'Sort by deadline';
    }

    getCsvValue(item) {
        return item.deadline ? Moment(item.deadline).format("YYYY-MM-DD") : '';
    }

    getValue(item) {return item.deadline}

    getAggregateClass() {return AggregateMoment}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.RANGE
    ]}

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.item.deadline ? i.item.deadline.unix() : Moment('1900-01-01 00:00:00').unix()],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }

    get AggregateComponent() {return AggregateMomentComponent.bind(null, this.getAggregateOptions())}

    // IMPORT

    normalizeCSVValue(value) {
        return normalizeDate(value);
    }

    getComponentViewInImport() {
        return FieldDateViewInImport;
    }

}